import { Component, OnInit, Input } from '@angular/core';
import { AppUris } from '../../../entities';
import { AppService } from '../../../app.service';

@Component({
  selector: 'breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {
  @Input('route') route: string = ""; // route name in new ui
  @Input('oldRoute') oldRoute: string = ""; // Link to old undercarriage ui
  @Input('currentRoute') currentRoute: boolean = false;
  @Input('type') type: string = 'route';
  @Input('label') label: string = '';
  appUris: AppUris = new AppUris();

  constructor(private _appService: AppService) { }

  ngOnInit() {
    this._appService.getAppUris().subscribe(result => { this.appUris = result; });
  }

}
